import React from "react";
import { Box, Chip, Skeleton } from "@mui/material";
import Typography from "@mui/material/Typography";
import { colors } from "src/config/colors";
import { MainProductInfoSchema } from "src/models/newProduct/getMainProductInfo";
import { useRouter } from "next/router";

interface ProductInfoListProps {
  mainProductInfo?: MainProductInfoSchema[];
  isLoadingProductInfo?: boolean;
}

const ProductInfoList: React.FC<ProductInfoListProps> = ({
  mainProductInfo,
  isLoadingProductInfo,
}) => {
  const router = useRouter();

  return (
    <Box>
      <Typography
        component="h6"
        sx={{
          fontSize: {
            xs: "16px",
            tb: "18px",
            color: colors.black,
            fontWeight: 500,
            marginBottom: "16px",
          },
        }}
      >
        Информация о товаре
      </Typography>
      {isLoadingProductInfo ? (
        Array.from({ length: 3 }).map((value, index, array) => {
          return (
            <React.Fragment key={index}>
              <Skeleton width="80%" height="35px" />
              <Skeleton width="50%" height="30px" />
            </React.Fragment>
          );
        })
      ) : (
        <Box>
          {mainProductInfo?.map((mainProductInfo, index) => {
            return (
              <React.Fragment key={mainProductInfo.value}>
                <Box
                  sx={{
                    display:
                      mainProductInfo.variants === null ? "flex" : "block",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "14px", tb: "16px" },
                      color: colors.gray3,
                    }}
                  >
                    {mainProductInfo.name}:
                  </Typography>
                  {mainProductInfo.variants === null && (
                    <>
                      &nbsp;
                      <Typography
                        sx={{
                          fontSize: { xs: "14px", tb: "16px" },
                          color: colors.black,
                        }}
                      >
                        {mainProductInfo.value}
                      </Typography>
                    </>
                  )}
                </Box>
                {mainProductInfo.variants?.map(
                  (value, index) =>
                    value.name && (
                      <Chip
                        key={value.slug}
                        sx={{
                          marginBottom: 1.5,
                          marginRight: 1,
                          fontSize: { xs: "12px", tb: "14px" },
                          flexWrap: "wrap",
                          height: "auto",
                          minHeight: "32px",
                          cursor: "pointer",
                          backgroundColor: "transparent",
                          color: value.is_active ? colors.blue2 : colors.black2,
                          border: value.is_active
                            ? "1px solid #3C56CB"
                            : "1px solid #ACACAC",
                          borderRadius: "8px",
                          ":hover": {
                            opacity: "0.6",
                            backgroundColor: "transparent",
                          },
                          ".MuiChip-label": {
                            whiteSpace: "normal",
                          },
                        }}
                        onClick={() =>
                          value.slug !== null && router.push(value.slug)
                        }
                        label={value.name}
                      />
                    )
                )}
              </React.Fragment>
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export default ProductInfoList;
